/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Helmet } from 'react-helmet';

import { addLazyLoadToIframes, getScriptTags } from 'bundles/shared-articles/utils/socialEmbeds';

type Props = {
  htmlString: string;
};

const styles = {
  mediaWrapper: () => css`
    min-height: 400px;
    padding-top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;

    iframe {
      max-width: 100%;
    }

    blockquote {
      margin: 0 !important;
      border: none !important;
      padding: 0 !important;
      display: block !important;

      & > p {
        /* Override just the font size, other styles are coming from .rc-RichText blockquote p */
        /* stylelint-disable-next-line cds-stylelint/cds-typography-utility  */
        font-size: var(--cds-font-size-250) !important;
        line-height: var(--cds-line-height-350) !important;
        color: var(--cds-color-grey-975) !important;
      }

      &::before,
      &::after {
        content: '' !important;
      }
    }
  `,
};

const SocialMediaPost = ({ htmlString }: Props) => {
  const content = addLazyLoadToIframes(htmlString);
  const scripts = getScriptTags(htmlString);

  if (!content) {
    return null;
  }

  return (
    <React.Fragment>
      {scripts && (
        <Helmet>
          {scripts.map((scr: string) => {
            return <script src={scr} async />;
          })}
        </Helmet>
      )}
      <div
        css={styles.mediaWrapper}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
        data-testid="social-media-post"
      />
    </React.Fragment>
  );
};

export default React.memo(SocialMediaPost);
